export enum EventEnum {
  REAUTHENTICATION_ERROR = 'REAUTHENTICATION_ERROR',
}
